/* BaseWizardUIMixin.js */

"use strict";
const _ = require("lodash");
let mixin = (superKlass) =>
    class BaseWizardUIMixin extends superKlass {
        /**
         * Show the base wizard page.
         */
        pmShowBaseWizardPage(continuation, wizFormRun) {
            let prom = Promise.resolve();
            let component = this.findComponentFromContinuation(continuation);
            if (component && _.isFunction(component.launchWizard)) {
                prom = new Promise((resolve, reject) => {
                    Promise.resolve()
                        .then(() => {
                            return component.launchWizard(wizFormRun);
                        })
                        .catch(reject) //if the launch fails reject this puppy
                        .then(() => {
                            //this seems very funky to me but ¯\_(ツ)_/¯
                            wizFormRun.webCompleted = resolve;
                            wizFormRun.error = reject;
                        });
                });
            }
            return prom;
        }

        /**
         * Start showing the progress of a NIB.
         * @param continuation
         * @param progressObj
         */
        showStartNIBProgress(continuation, progressObj) {
            let component = this.findComponentFromContinuation(continuation);
            if (component && _.isFunction(component.startNIBProgress)) {
                component.startNIBProgress(progressObj);
            }
        }

        /**
         * Dismiss the progress window in a wizard.
         * @param continuation
         * @param progressObj
         */
        stopShowNIBProgress(continuation, progressObj) {
            let component = this.findComponentFromContinuation(continuation);
            if (component && _.isFunction(component.stopNIBProgress)) {
                component.stopNIBProgress(progressObj);
            }
        }

        /**
         * Start showing the progress of a NIB.
         * @param continuation
         * @param progressObj
         */
        showUpdateNIBProgress(continuation, progressObj) {
            let component = this.findComponentFromContinuation(continuation);
            if (component && _.isFunction(component.updateNIBProgress)) {
                component.updateNIBProgress(progressObj);
            }
        }

        setFinishButtonTitle(continuation, title) {
            let component = this.findComponentFromContinuation(continuation);
            if (component && _.isFunction(component.setFinishButtonTitle)) {
                component.setFinishButtonTitle(title);
            }
        }

        /**
         * Clear the base wizard page.
         */
        pmClearBaseWizardPage(continuation) {
            let prom = Promise.resolve();
            let component = this.findComponentFromContinuation(continuation);
            if (component && _.isFunction(component.clearWizard)) {
                prom = Promise.resolve().then(() => {
                    return component.clearWizard();
                });
            }
            return prom;
        }
    };
module.exports = mixin;
